module.exports = __webpack_public_path__ + "assets/img/16_1808_big.c5849eac.jpg";